import auth from "@/lang/sections/auth";
import generic from "@/lang/sections/generic";
import layouts from "@/lang/sections/layouts";
import components from "@/lang/sections/components";
import emailOnboarding from "@/lang/sections/emailOnboarding";
import matOnboarding from "@/lang/sections/matOnboarding";
import email from "@/lang/sections/email";
import common from "@/lang/sections/common";
import settings from "@/lang/sections/settings";
import comply from "@/lang/sections/comply";
import sms from "@/lang/sections/sms";
import smsOnboarding from "@/lang/sections/smsOnboarding";
import complyOnboarding from "@/lang/sections/complyOnboarding";
import publicScreens from "@/lang/sections/publicScreens";
import support from "@/lang/sections/support";
import integrations from "@/lang/sections/integrations";

export default {
  translation: {
    auth,
    layouts,
    generic,
    comply,
    components,
    emailOnboarding,
    matOnboarding,
    email,
    common,
    settings,
    sms,
    smsOnboarding,
    complyOnboarding,
    publicScreens,
    support,
    integrations,
  },
} as const;
